import React, { useState } from "react";
import styles from "./Service.module.scss";
import { AppHeader } from "./components/serviceContent/components/AppHeader";
import ServiceContent from "./components/serviceContent/ServiceContent";
import FoldingContent from "../../../../../../../../components/folding/FoldingContent";
import Button from "../../../../../../../../components/ripple/Button";
import { immutableArraySlice, scrollToAnchor } from "../../../../../../../../helpers/common";
import { DEBUG } from "../../../../../../../../settings/global";
import { dispatchNotification } from "../../../../../../../../layouts/app/components/notificationSystem/notifications";
import { handleFeaturesSwitch } from "../../../../../../basic/appsIncluded/components/features/helpers/featuresActions";
import { updateBodyBuilder } from "../../../../../../../../redux/actions/DeploymentActions";
import { connect } from "react-redux";
import { authNotify, onAuthError, saveLocationForRedirect } from "../../../../../../../../helpers/data/get/user";

function Service({app, messages, onProjectSave, bodyBuilder, dispatch,}) {

    const [loadingSave, setLoadingSave] = useState(false);

    const stored = typeof window !== 'undefined' ? localStorage.getItem('blocks_fold') : undefined;
    const id = `app-${app._id}`;
    const getFoldState = () => {
        return JSON.parse(stored)?.find(block => block.id === id)?.folded
    }

    const [folded, setFolded] = useState(typeof window !== 'undefined' ? getFoldState() : false);

    const handleFold = (fold) => {
        setFolded(fold);
        let newStorage = [];
        if (stored) {

            const blocks = JSON.parse(stored);
            const foundIndex = JSON.parse(stored).findIndex(block => block.id === id);

            if (foundIndex !== -1) {
                newStorage = [
                    ...blocks.slice(0, foundIndex),
                    ...blocks.slice(foundIndex + 1),
                    ...[{
                        ...JSON.parse(stored)[foundIndex],
                        ...{folded: fold}
                    }]
                ]
            } else {
                newStorage = [...JSON.parse(stored), ...[{id, folded: fold}]]
            }
        } else {
            newStorage = [{id, folded: fold}];
            if (!!DEBUG) dispatchNotification({
                message: 'I, the code, will try to remember your choice!',
                type: 'success',
            })
        }
        localStorage.setItem('blocks_fold', JSON.stringify(newStorage))
    };

    const onDelete = () => {

        // clear localStorage to optimize
        if (!app._id && app._id !== 0) return;
        const stored = JSON.parse(localStorage.getItem('blocks_fold') || '[]');

        const toDelete = stored.filter((entry) => entry.id.match(/\d+/gi)?.toString() === app._id?.toString());
        let newStorage = stored;

        toDelete.map((entry) => {
            const index = newStorage.findIndex(_entry => _entry.id.match(/\d+/gi)?.toString() === app._id?.toString())
            newStorage = [
                ...newStorage.slice(0, index),
                ...newStorage.slice(index + 1),
            ]
        })

        localStorage.setItem('blocks_fold', JSON.stringify(newStorage))

        if (app.type === 'feature') {
            handleFeaturesSwitch([app], true);
        } else {
            dispatch(updateBodyBuilder({
                ...bodyBuilder,
                ...{[app.type]: immutableArraySlice(app, bodyBuilder[app.type], '_id')}
            }));
        }
    }

    const onSave = () => {
        setLoadingSave(true);
        onProjectSave({
            onSuccess: () => {
                handleFold(true);
                setTimeout(() => scrollToAnchor(`app-${app._id}`, undefined, true, 'builder-container'), 0);
                setLoadingSave(false);
            },
            onError: (data) => {
                if (
                    data?.error?.status === 401
                    || data?.responseBody?.message?.includes('401')
                    || data?.responseBody?.message?.includes('Authentication required')
                ) {
                    authNotify();
                    saveLocationForRedirect();
                    onAuthError();
                } else {
                    setLoadingSave(false);
                }
            }
        });
    }

    const _messages = messages?.filter(m => m.block === `app-${app._id}`);
    const warnings = _messages?.filter(m => m.type === 'warning');
    const errors = _messages?.filter(m => m.type === 'error');

    let hint = '';

    if (!!warnings?.length) hint = ` ${styles['app--warning']}`;
    if (!!errors?.length) hint = ` ${styles['app--error']}`

    return (
        <div className={styles.app + hint} id={`app-${app._id}`}>
            <div className={styles.app__header}>
                <AppHeader app={app}/>
                <div className={styles.actions}>
                    {
                        !!folded &&
                        <Button
                            className={styles.actions__button}
                            icon='fas fa-cog'
                            displayType='text'
                            type='button'
                            onClick={() => {
                                handleFold(false);
                            }}
                            visuals={{borderRadius: '50%'}}
                        />
                    }
                    {
                        <Button
                            className={styles.actions__button}
                            displayType='text'
                            type='button'
                            onClick={onSave}
                            visuals={{borderRadius: '50%'}}
                            disabled={loadingSave}
                            icon={loadingSave ? 'fas fa-spinner fa-spin' : 'fas fa-check'}
                        />
                    }
                </div>
            </div>
            <FoldingContent folded={folded}>
                <ServiceContent app={app}/>
                <div className={styles.app__bottom}>
                    <Button
                        className={styles.app__bottom__button}
                        displayType='text'
                        onClick={onDelete}
                        title='Remove service'
                        disabled={loadingSave}
                    />
                    <Button
                        className={styles.app__bottom__button}
                        onClick={onSave}
                        title='Done'
                        disabled={loadingSave}
                        iconRight={loadingSave ? 'fas fa-spinner fa-spin' : 'fas fa-check'}
                    />
                </div>
            </FoldingContent>
        </div>
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
})

export default connect(mapStateToProps)(Service)